var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilledinfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.760254C3.71875 0.760254 0.25 4.26025 0.25 8.51025C0.25 12.7915 3.71875 16.2603 8 16.2603C12.25 16.2603 15.75 12.7915 15.75 8.51025C15.75 4.26025 12.25 0.760254 8 0.760254ZM8 14.7603C4.53125 14.7603 1.75 11.979 1.75 8.51025C1.75 5.07275 4.53125 2.26025 8 2.26025C11.4375 2.26025 14.25 5.07275 14.25 8.51025C14.25 11.979 11.4375 14.7603 8 14.7603ZM8 4.19775C7.25 4.19775 6.6875 4.7915 6.6875 5.51025C6.6875 6.26025 7.25 6.82275 8 6.82275C8.71875 6.82275 9.3125 6.26025 9.3125 5.51025C9.3125 4.7915 8.71875 4.19775 8 4.19775ZM9.75 12.1353V11.3853C9.75 11.1978 9.5625 11.0103 9.375 11.0103H9V7.88525C9 7.69775 8.8125 7.51025 8.625 7.51025H6.625C6.40625 7.51025 6.25 7.69775 6.25 7.88525V8.63525C6.25 8.854 6.40625 9.01025 6.625 9.01025H7V11.0103H6.625C6.40625 11.0103 6.25 11.1978 6.25 11.3853V12.1353C6.25 12.354 6.40625 12.5103 6.625 12.5103H9.375C9.5625 12.5103 9.75 12.354 9.75 12.1353Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledinfo);
export default __webpack_public_path__ + "static/media/Filledinfo.fa55f02417d686deb4b4782108930f1d.svg";
export { ForwardRef as ReactComponent };